









































import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  onUpdated,
  computed,
  ref,
  Ref
} from '@vue/composition-api'
import PriceContainer from './PriceContainer.vue'
import { formatNumber } from '@/utils/number-format.utils'
import { ElementRef } from '@/types/common.types'
import { isMobile } from '@/utils/window-size.utils'
import { calculatePriceContainerMargins } from '@/utils/style.utils'

export default defineComponent({
  components: {
    PriceContainer
  },
  props: {
    offer: Object,
    alternativeDelivery: Boolean,
    hasSpecialCampaign: Boolean,
    isAreaTypeChangeOperator: Boolean,
    isAreaTypeFwa: Boolean
  },
  setup (props, context) {
    const offerPriceRef: Ref<ElementRef> = ref({} as ElementRef)
    const pricePerMonthRef: Ref<ElementRef> = ref({} as ElementRef)

    const computedPricePerMonthMargin = ref(0)
    const computedOfferPriceMargin = ref(0)
    const priceTitleSizeHighest = ref(0)

    const goFurther = () => { context.emit('onGoFurther') }

    const price = computed(() => props.alternativeDelivery ? props.offer?.OrdinaryPriceExpressDelivery : props.offer?.Price)
    const partPaymentPrice = computed(() => props.alternativeDelivery ? props.offer?.PartPaymentOrdinaryPrice : props.offer?.PartPaymentPrice)
    const showPartialPaymentPrice = computed(() => !props.isAreaTypeChangeOperator && !props.isAreaTypeFwa)

    const setMarginSizes = () => {
      if (isMobile()) {
        computedPricePerMonthMargin.value = 0
        computedOfferPriceMargin.value = 0
        priceTitleSizeHighest.value = 0

      } else {
        const offerPriceHeight = offerPriceRef.value.$el.firstChild.clientHeight
        const pricePerMonthHeight = pricePerMonthRef.value?.$el?.firstChild.clientHeight
        const calculatedMargins = calculatePriceContainerMargins(offerPriceHeight, pricePerMonthHeight)

        computedPricePerMonthMargin.value = calculatedMargins.computedPricePerMonthMargin
        priceTitleSizeHighest.value = calculatedMargins.priceTitleSizeHighest
      }
    }

    onUpdated(() => {
      setMarginSizes()
    })

    onMounted(() => {
      setMarginSizes()
      window.addEventListener('resize', setMarginSizes)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setMarginSizes)
    })

    return {
      formatNumber,
      goFurther,
      offerPriceRef,
      pricePerMonthRef,
      computedOfferPriceMargin,
      computedPricePerMonthMargin,
      priceTitleSizeHighest,
      price,
      partPaymentPrice,
      showPartialPaymentPrice
    }
  }
})

